import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  // base: process.env.BASE_URL,
  // base: './vueTipp/',
  base: process.env.VUE_APP_BASE_URL, // samma sak som base: './vueTipp/'
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/schema',
      name: 'schema',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Schema.vue')
    },
    {
      path: '/ceremoni',
      name: 'ceremoni',
      component: () => import(/* webpackChunkName: "about" */ './views/Ceremoni.vue')
    },
    {
      path: '/rsvp',
      name: 'rsvp',
      component: () => import(/* webpackChunkName: "about" */ './views/Rsvp.vue')
    },
    {
      path: '/middag',
      name: 'middag',
      component: () => import(/* webpackChunkName: "about" */ './views/Middag.vue')
    },
    {
      path: '/florens',
      name: 'florens',
      component: () => import(/* webpackChunkName: "about" */ './views/Florens.vue')
    }
  ]
});
